import '../../scss/components/_country-switcher.scss';
const changeCountry = (country) => {
    const countrySwitcher = document.querySelector('#country-switcher');
    if (countrySwitcher) {
        JSON.parse(countrySwitcher.dataset.selector).forEach((selectorElement) => {
            const blockSelector = document.querySelector(selectorElement);
            countrySwitcher.classList.remove('US');
            countrySwitcher.classList.remove('CA');
            blockSelector.classList.remove('US');
            blockSelector.classList.remove('CA');
            if (country) {
                countrySwitcher.classList.add(country);
                blockSelector.classList.add(country);
            }
            else {
                countrySwitcher.classList.add('US');
                blockSelector.classList.add('US');
            }
        });
    }
};
const detectCountry = () => {
    fetch('https://ipinfo.io/json')
        .then((response) => response.json())
        .then(({ country }) => {
        return country === 'CA' ? 'CA' : 'US';
    })
        .catch((error) => {
        return 'US';
    });
};
export { changeCountry, detectCountry };
